webpackJsonp([206677684021311],{

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Models = __webpack_require__(18);
	
	var _Models2 = _interopRequireDefault(_Models);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Models2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'cidPrefix'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'cidPrefix'
	      ),
	      ' property for "client id prefix", and is used for generating the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'cid'
	      ),
	      ' value for the model.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To see how it\'s used, see the docs for the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'generateCid()'
	      ),
	      ' method ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/models/properties/generateCid/' },
	        'here'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default implementation looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      cidPrefix: \'c\',\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Whenever you create a model, it is assigned a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'cid'
	      ),
	      ', which is generated using the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'cidPrefix'
	      ),
	      ' followed by an integer.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s use this code to illustrate:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Model } from \'lore-models\';\n\n      const Tweet = Model.extend();\n\n      const t1 = new Tweet();\n      const t2 = new Tweet();\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the example above, ',
	      _react2.default.createElement(
	        'code',
	        null,
	        't1'
	      ),
	      ' will have a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'cid'
	      ),
	      ' of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'c1'
	      ),
	      ', and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        't2'
	      ),
	      ' will have a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'cid'
	      ),
	      ' of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'c2'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If we want to change this, we can define a custom ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'cidPrefix'
	      ),
	      ' like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Model } from \'lore-models\';\n\n      const Tweet = Model.extend({\n        cidPrefix: \'tweet\'\n      });\n\n      const t1 = new Tweet();\n      const t2 = new Tweet();\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the code above, we define a custom ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'cidPrefix'
	      ),
	      ' declaring that all ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'cid'
	      ),
	      ' values should begin with ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet'
	      ),
	      '. This will mean ',
	      _react2.default.createElement(
	        'code',
	        null,
	        't1'
	      ),
	      ' will now have a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'cid'
	      ),
	      ' of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet1'
	      ),
	      ', and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        't2'
	      ),
	      ' will now have a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'cid'
	      ),
	      ' of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet2'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-models-properties-cid-prefix-js-d968a5456985db4b6802.js